import { FormikProps } from 'formik'
import React from 'react'

import { FormValues } from '../../api/services/pricing/types.ts'
import Button from '../common/Button/Button.tsx'
import Input from '../common/forms/Input/Input.tsx'

const PricesGroup = ({
  formik,
  isDisabled = false,
  data
}: {
  formik: FormikProps<FormValues>
  isDisabled?: boolean
  data: FormValues
}) => {
  const errorsFormikExists = Object.keys(formik.errors).length > 0
  const inputClassName = `py-4 px-4 flex-1 text-title-md text-right font-bold ${isDisabled ? 'text-blue-600' : ''}`

  return (
    <form
      onSubmit={formik.handleSubmit}
      className="flex flex-col justify-between max-w-full overflow-x-auto"
    >
      <div className="flex flex-col md:flex-row justify-between max-w-full overflow-x-auto">
        <Input
          id="price1m"
          name="price1m"
          type="number"
          formik={isDisabled ? null : formik}
          placeholder="Dieta na 1 miesiąc"
          disabled={isDisabled}
          value={
            isDisabled
              ? data.price1m.toString()
              : formik.values.price1m.toString()
          }
          inputClassName={inputClassName}
        />
        <Input
          id="price3m"
          name="price3m"
          type="number"
          formik={isDisabled ? null : formik}
          placeholder="Dieta na 3 miesiące"
          disabled={isDisabled}
          value={
            isDisabled
              ? data.price3m.toString()
              : formik.values.price3m.toString()
          }
          inputClassName={inputClassName}
        />
        <Input
          id="price6m"
          name="price6m"
          type="number"
          formik={isDisabled ? null : formik}
          placeholder="Dieta na 6 miesięcy"
          disabled={isDisabled}
          value={
            isDisabled
              ? data.price6m.toString()
              : formik.values.price6m.toString()
          }
          inputClassName={inputClassName}
        />
        <Input
          id="price12m"
          name="price12m"
          type="number"
          formik={isDisabled ? null : formik}
          placeholder="Dieta na 12 miesięcy"
          disabled={isDisabled}
          value={
            isDisabled
              ? data.price12m.toString()
              : formik.values.price12m.toString()
          }
          inputClassName={inputClassName}
        />
      </div>
      {!isDisabled && (
        <div>
          <Button
            variant="filled"
            fullWidth
            size="medium"
            color="primary"
            type="submit"
            className="mb-3"
            disabled={formik.isSubmitting || errorsFormikExists}
          >
            {formik.isSubmitting ? 'Zapisywanie...' : 'Zapisz zmiany'}
          </Button>
        </div>
      )}
    </form>
  )
}
export default PricesGroup
